import React from 'react'
import { isNilOrEmpty } from '@neo/ramda-extra'
import { s } from '@vega/styled'
import { RadioButton, RadioButtonField, TextField } from '@vega/components'
import { Subheading } from './layoutComponents'
import CreditProfileSection from './CreditProfileSection'
import CreditScoreSection from './CreditScoreSection'

function CreditReportSummary({ applicantPathId, reportData }) {
  if (isNilOrEmpty(reportData?.profile) && isNilOrEmpty(reportData?.creditScores))
    return null

  return (
    <>
      <CreditScoreSection creditScores={reportData?.creditScores} />
      <CreditProfileSection profile={reportData?.profile} />

      <Subheading>Do you want to view the credit history?</Subheading>

      <RadioButtonField
        name={`${applicantPathId}.creditHistory.toggle`}
        aria-label="credit history toggle"
        containerStyle={s('w-full')}
      >
        <RadioButton value={true}>Yes</RadioButton>
        <RadioButton value={false}>No</RadioButton>
      </RadioButtonField>

      <Subheading>Additional notes</Subheading>
      <TextField
        name={`${applicantPathId}-additional-notes`}
        placeholder="Type your notes"
        optional={true}
      />
    </>
  )
}

export { CreditReportSummary }
